import { useEffect } from 'react';
import { useChat } from '@/context/ChatContext';
import { Layout } from '@/components/Layout';

export function ChatPage() {
  const { loadConversations, error, clearError } = useChat();

  useEffect(() => {
    loadConversations();
  }, [loadConversations]);

  return (
    <>
      <Layout />

      {/* Error Toast */}
      {error && (
        <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-50 animate-fade-in">
          <div className="bg-red-500/90 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3">
            <span className="material-icons">error</span>
            <p className="text-sm">{error}</p>
            <button
              onClick={clearError}
              className="ml-2 hover:opacity-70"
            >
              <span className="material-icons">close</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
}
